import { Container, LabelContainer, ActionButtonContainer } from './Announcement.styles';
import { ANNOUNCEMENT_VARIANTS } from './constants';

export type AnnouncementProps = {
  id?: string;
  ActionButton?: React.ReactNode;
  Label?: React.ReactNode;
  children?: React.ReactNode;
  variant?: ANNOUNCEMENT_VARIANTS;
};

export const Announcement = ({
  id,
  ActionButton,
  Label,
  variant = ANNOUNCEMENT_VARIANTS.DEFAULT,
  children,
  ...props
}: AnnouncementProps) => (
  <Container id={id} data-variant={variant} {...props}>
    {Label && <LabelContainer>{Label}</LabelContainer>}
    <div>{children}</div>
    {ActionButton && <ActionButtonContainer>{ActionButton}</ActionButtonContainer>}
  </Container>
);
